// Only edit in client instances
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
})
export class ClientModule {
    constructor() {
        /* empty */
    }
}
